import styled from 'styled-components';

export const NavSearchWrapper = styled.div`
  margin: 6px 25px 4px;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  /* The theme value is always set for the default theme, so --nav-search-bg alone never wins. */
  background-color: var(
    --nav-search-surface,
    ${({ theme }) => theme?.colors?.primary?.semiTransparent || 'var(--nav-search-bg)'}
  );
  border-radius: var(--input-border-radius);
  padding: 8px 16px;
  border: 1px solid var(--nav-search-border-color);
  transition: border-color 0.15s ease;

  &:focus-within {
    border-color: ${({ theme }) => theme?.colors?.secondary?.main || 'var(--mainGreen)'};
  }
`;

const SearchIconSvg = () => (
  <svg width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 7.32803C3.75 4.56956 5.98619 2.33337 8.74466 2.33337C11.5031 2.33337 13.7393 4.56956 13.7393 7.32803C13.7393 10.0865 11.5031 12.3227 8.74466 12.3227C5.98619 12.3227 3.75 10.0865 3.75 7.32803ZM8.74466 1.33337C5.4339 1.33337 2.75 4.01727 2.75 7.32803C2.75 10.6388 5.4339 13.3227 8.74466 13.3227C10.1473 13.3227 11.4374 12.841 12.4586 12.0339L14.3675 13.9379C14.563 14.1329 14.8796 14.1325 15.0746 13.937C15.2696 13.7415 15.2692 13.4249 15.0737 13.2299L13.1895 11.3505C14.1526 10.2869 14.7393 8.87597 14.7393 7.32803C14.7393 4.01727 12.0554 1.33337 8.74466 1.33337Z"
      fill="currentColor"
    />
  </svg>
);

export const SearchIcon = styled(SearchIconSvg)`
  flex-shrink: 0;
  color: var(--cadetGray);
`;

export const SearchInputField = styled.input`
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: var(--nav-search-text);
  caret-color: ${({ theme }) => theme?.colors?.secondary?.main || 'var(--mainGreen)'};
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 19px;
  min-width: 0;

  &::placeholder {
    color: var(--input-placeholder-color);
  }
`;

export const ClearButton = styled.button`
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--cadetGray);
  width: 14px;
  height: 14px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 1.5px;
    background: currentColor;
    border-radius: 1px;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  &:hover {
    color: var(--nav-search-text);
  }
`;

export const NoResults = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 15px;
  color: var(--nav-item-text, rgba(255, 255, 255, 0.4));
  font-size: 13px;
`;

export const MatchCount = styled.div`
  padding: 2px 6px 4px;
  color: var(--cadetGray);
  font-size: 11px;
  text-align: right;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;
